import React from "react";
import fieldPropTypes from "./field-prop-types";

const BorderedPanel = ({
  field: {
    data: { items },
    name,
    params
  },
  components: { Goal, TaskList },
  appData: { settings }
}) => {
  return (
    <>
      {name === "completed_other_tasks_container" ? (
        <>
          <p className='other_tasks text-web-sdk TDFieldOptionBold'>
            {items[0].subtitle.text}
          </p>
          <TaskList tasks={items.filter(i => i.type === "item").slice(1)} />
        </>
      ) : name === "other_tasks_container" ? (
        <TaskList tasks={items.filter(i => i.type === "item")} />
      ) : name.includes("additional_info") ? (
        <p className='additional_info'>{items[0].title.text}</p>
      ) : (
        <Goal
          items={items}
          name={name}
          isInitiallyOpen={!params.includes("TDFieldOptionNotCollapsed")}
          TaskList={TaskList}
          settings={settings}
        />
      )}
    </>
  );
};

BorderedPanel.propTypes = fieldPropTypes;
export default BorderedPanel;
